export default {
  methods: {
    changeThemeColor (themeColor, callback) {
      if (themeColor) {
        require.ensure([], function () {
          require('../../theme/' + themeColor + '/index.css')
          this.toggleClass(document.body, 'custom-' + themeColor)
          if (typeof callback === 'function') {
            callback()
          }
        }.bind(this))
      }
    },

    toggleClass (element, className) {
      if (!element || !className) {
        return
      }
      element.className = className
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/changeThemeColor.js